





































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { fullDateTime } from '@/helpers/dateFormatter';
import { ProjectData } from '@/interfaces/ProjectData';
import { ProjectListItem } from '@/interfaces/ProjectListItem';
import { ProductGroupTypes } from '@/enums/ProductGroupTypes';
import { ElTable } from 'element-ui/types/table';
import { eventBus, eventBusEvents } from '@/helpers/eventBusHelper';

interface Fields {
    name: string | null;

    [key: string]: string | null;
}

@Component({
    name: 'MyProjects',
})
export default class MyProjects extends Vue {
    public $refs!: {
        projectsTable: ElTable;
    };

    protected editMode = false;

    protected errorMessages: Fields = {
        name: null,
    };

    @Action('projects/getMyProjects')
    private getMyProjects!: (
        productGroup: ProductGroupTypes,
    ) => Promise<unknown>;
    @Action('projects/deleteSingleProject') private deleteSingleProject!: (
        id: number,
    ) => void;
    @Action('projects/updateProject')
    private updateProject!: (projectData: ProjectData) => void;
    @Action('projects/addProject')
    private addProject!: (projectData: ProjectData) => void;
    @Action('projects/getSingleProject')
    private getSingleProject!: (id: number) => void;
    @Action('user/setActiveProductGroup') private setActiveProductGroup!: (
        productGroup: ProductGroupTypes,
    ) => void;

    protected get tableData() {
        return this.$store.getters['projects/myProjectsList'];
    }

    protected get isCustomer() {
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.CustomerRelations
        );
    }

    protected get isTrademark() {
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.Trademark
        );
    }

    protected get isGoodwill() {
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.Goodwill
        );
    }

    protected get isTechnology() {
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.Technology
        );
    }

    protected get isSoftware() {
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.Software
        );
    }

    protected get isNoCategoryDefined() {
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.None
        );
    }

    protected get myProjectsTitle() {
        return this.getAppropriatePhrase(
            'Trademark',
            'Customer relations',
            'Goodwill',
            'Technology',
            'Software',
            'My projects',
        );
    }

    protected getAppropriatePhrase(
        trademarkPhrase: string,
        customerPhrase: string,
        goodwillPhrase: string,
        technologyPhrase: string,
        softwarePhrase: string,
        generalPhrase: string,
    ) {
        if (this.isTrademark) {
            return trademarkPhrase;
        }

        if (this.isCustomer) {
            return customerPhrase;
        }

        if (this.isGoodwill) {
            return goodwillPhrase;
        }

        if (this.isTechnology) {
            return technologyPhrase;
        }

        if ((this, this.isSoftware)) {
            return softwarePhrase;
        }

        return generalPhrase;
    }

    protected resolveCategoryName(abbreviation: string) {
        switch (abbreviation) {
            case ProductGroupTypes.Trademark:
                return 'Trademark';
            case ProductGroupTypes.CustomerRelations:
                return 'Customer relations';
            case ProductGroupTypes.Goodwill:
                return 'Goodwill';
            case ProductGroupTypes.Technology:
                return 'Technology';
            case ProductGroupTypes.Software:
                return 'Software';
            default:
                return '';
        }
    }

    protected mounted() {
        eventBus.$emit(eventBusEvents.activateGlobalLoading);
        this.getMyProjects(this.$store.getters['user/activeProductGroup']).then(
            () => {
                eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
            },
        );
        const self = this;
        window.addEventListener('keyup', (event) => {
            if (event.keyCode === 27) {
                this.escPressed();
            }
        });
    }

    protected beforeDestroy() {
        document.removeEventListener('keyup', this.escPressed);
    }

    protected escPressed() {
        let indexToBeRemoved = null;
        this.tableData.forEach((tableItem: any, index: number) => {
            if (tableItem.edit) {
                if (tableItem.id) {
                    tableItem.edit = false;
                    return;
                }
                indexToBeRemoved = index;
            }
        });
        this.tableData.splice(indexToBeRemoved, 1);
        this.editMode = false;
        // if (this.tableData[0].edit === true && !this.tableData[0].id) {
        //     this.tableData.shift();
        //     this.editMode = false;
        // }
    }

    protected initiateAddFolderMode() {
        if (!this.editMode) {
            this.$refs.projectsTable.clearSort();
            this.tableData.unshift({
                name: '',
                prodGroup: '',
                description: '',
                projectItems: 0,
                created: '-',
                updatedAt: '-',
                edit: true,
            });
            this.editMode = true;
        }
    }

    protected async finalizeFolderAction(
        index: number,
        singleProjectItem: ProjectListItem,
    ) {
        if (
            singleProjectItem.name === '' ||
            singleProjectItem.prodGroup === ''
        ) {
            return;
        }
        if (!singleProjectItem.id) {
            const projectData: ProjectData = {
                name: singleProjectItem.name,
                description: singleProjectItem.description,
                prodGroup: this.isNoCategoryDefined
                    ? singleProjectItem.prodGroup
                    : undefined,
            };

            try {
                await this.addProject(projectData);
            } catch (e) {
                const pointerArray = e.response.data.errors[0].source.pointer.split(
                    '/',
                );
                const pointer = pointerArray[pointerArray.length - 1];
                this.errorMessages[pointer] = e.response.data.errors[0].detail;
                this.$message.error(e.response.data.errors[0].detail);
                return new Error(e);
            }
        } else {
            const projectData: ProjectData = {
                id: singleProjectItem.id,
                name: singleProjectItem.name,
                description: singleProjectItem.description,
                prodGroup: singleProjectItem.prodGroup,
            };
            try {
                await this.updateProject(projectData);
            } catch (e) {
                const pointerArray = e.response.data.errors[0].source.pointer.split(
                    '/',
                );
                const pointer = pointerArray[pointerArray.length - 1];
                this.errorMessages[pointer] = e.response.data.errors[0].detail;
                this.$message.error(e.response.data.errors[0].detail);
                return new Error(e);
            }
        }

        this.editMode = false;
    }

    protected async enterFolder(id: number, prodGroup: ProductGroupTypes) {
        await this.toggleActiveProductGroup(prodGroup);
        this.getSingleProject(id);
        this.$router.push({ name: 'SingleFolder' });
    }

    protected handleDelete(index: number, isMain: boolean, id = -1) {
        if (isMain) {
            return;
        }

        if (id === -1) {
            this.escPressed();
            this.editMode = false;
        } else {
            this.deleteSingleProject(id);
        }
    }

    protected handleEdit(
        index: number,
        id = -1,
        isMain: boolean,
        isEditable: boolean,
    ) {
        if (isEditable || isMain) {
            return;
        }
        const item = this.tableData.filter(
            (tableItem: ProjectData) => tableItem.id === id,
        );
        if (!item) {
            throw new Error('The item ' + id + ' does not exist');
        }
        this.editMode = true;
        item[0].edit = true;
        // todo - send to api
    }

    protected saveInput(el: object) {
        // this.tableData[el].edit = false
    }

    protected formatDateTime(isoString: string) {
        if (new Date(isoString).toString() !== 'Invalid Date') {
            return fullDateTime(isoString);
        } else {
            return '-';
        }
    }

    protected onNavigateToSearch() {
        this.$router.push({ name: 'Welcome' });
    }

    protected async toggleActiveProductGroup(productGroup: ProductGroupTypes) {
        eventBus.$emit(eventBusEvents.activateGlobalLoading);
        await this.setActiveProductGroup(productGroup);

        eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
    }
}
